import { SfActivityWord, SfSortedSyllables } from "@/types/sfActivityTypes";
import { SfSyllable } from "@/types/spellingTypes";

export default (loadedWords: SfActivityWord[]) => {
  const words = [] as SfActivityWord[];
  for (const lw of loadedWords) {
    const sortedSyllables = getSortedSyllables(lw);
    if (sortedSyllables) {
      const w = {
        ...lw,
        sortedSyllables,
        spellingOptions: getSpellingOptions(
          sortedSyllables.correct,
          sortedSyllables.incorrect,
          6,
        ),
        wordOptions: getWordOptions(lw),
      };
      words.push(w);
    }
  }
  return words;
};

function getWordOptions(word: SfActivityWord) {
  const correct = { id: 0, value: word.value, word_id: word.id };
  const res = [...word.wrongWords, correct];
  res.sort(() => {
    return 0.5 - Math.random();
  });
  return res;
}

function getSpellingOptions(
  correct: SfSyllable[],
  incorrect: SfSyllable[][],
  count: number,
) {
  const syllableCount = correct.length;
  const res = [];
  const used = [];
  for (let limit = 0; limit < 10000; limit++) {
    if (res.length < count) {
      let comp = "";
      const syllables = [];
      for (let i = 0; i < syllableCount; i++) {
        const r = Math.random();
        let s = null;
        if (r > 0.7 || res.length < 1) {
          s = correct[i];
        } else {
          s =
            incorrect[i][
              Math.floor(Math.random() * incorrect[i].length * 0.9999)
            ];
        }
        comp += s.value;
        syllables.push(s);
      }
      if (used.indexOf(comp) < 0) {
        res.push(syllables);
        used.push(comp);
      }
    }
  }
  res.sort(() => {
    return 0.5 - Math.random();
  });
  return res;
}

function getSortedSyllables(word: SfActivityWord): SfSortedSyllables | null {
  const correct = getCorrectSyllables(word);
  if (!correct) {
    // fail if correct syllables failed
    return null;
  }
  const incorrect = getSyllableWrongOptions(word, correct.length);
  if (!incorrect) {
    // fail if incorrect syllbales failed
    return null;
  }
  const res = {
    correct,
    incorrect,
    options: [] as SfSyllable[][],
  };
  res.incorrect = incorrect;
  res.options = [];
  for (const i in res.correct) {
    const ops = [...res.incorrect[i]];
    const pos = Math.floor(Math.random() * ops.length * 0.99999);
    ops.splice(pos, 0, res.correct[i]);
    res.options[i] = ops;
  }
  return res;
}

function getCorrectSyllables(word: SfActivityWord) {
  const res = [];
  for (const s of word.syllables) {
    if (s.is_correct == 1) {
      res[s.syllable_number] = s;
    }
  }
  if (res.length < 1) {
    // fail if word has no correct syllables
    return null;
  }
  for (const s of res) {
    if (!s) {
      // fail if there is a missing syllable
      return null;
    }
  }
  return res;
}

function getSyllableWrongOptions(word: SfActivityWord, count: number) {
  if (count == 1) {
    // return wrong words for monosyllables
    return [
      word.wrongWords.map((w) => {
        return { ...w, syllable_number: 1, is_correct: 0 } as SfSyllable;
      }),
    ];
  }
  const res = [] as SfSyllable[][];
  for (let i = 0; i < count; i++) {
    res.push([] as SfSyllable[]);
  }
  for (const s of word.syllables) {
    if (s.is_correct != 1) {
      res[s.syllable_number].push(s);
    }
  }
  let lenPerCol = 0;
  for (const ops of res) {
    if (ops.length < 1) {
      // fail if there are no alternatives for a syllable
      return null;
    }
    // find smallest amount of wrong alternatives for a syllables
    if (lenPerCol == 0) {
      lenPerCol = ops.length;
    } else if (lenPerCol > ops.length) {
      lenPerCol = ops.length;
    }
    // shuffle options
    ops.sort(() => {
      return 0.5 - Math.random();
    });
  }
  for (const ops of res) {
    if (ops.length > lenPerCol) {
      // remove extra options
      ops.splice(lenPerCol);
    }
  }
  return res;
}
